import TextAlign from '@tiptap/extension-text-align';

export const OrderedTextAlign = TextAlign.extend({
    addGlobalAttributes() {
        const types = this.options.types ?? ['heading', 'paragraph'];

        return [
            {
                types,
                attributes: {
                    textAlign: {
                        default: this.options.defaultAlignment ?? null,
                        parseHTML: (element) => element.style.textAlign || null,
                        renderHTML: (attributes) => {
                            const align = attributes['textAlign'];
                            if (!align) {
                                return {};
                            }

                            const indent = Number(attributes['indent'] ?? 0);
                            if (Number.isFinite(indent) && indent > 0) {
                                // Indent extension will render margin-left + text-align in the correct order.
                                return {};
                            }

                            return { style: `text-align: ${align};` };
                        },
                    },
                },
            },
        ];
    },
});
